
function offerForm() {
    return {
        bg_img_url: "",
        title: {
            text: "",
            text_color: "",
            font_size: "",
        },
        image_url: "",
        center_section: {
            type: "1",
            bullet_point: "",
            text_color: "",
            font_size: "",
            text: "",
            points: [
                {
                    text: "",
                },
            ],
        },
        pro_button: {
            text_color: "",
            bottom_color: "",
            top_color: "",
            show_price: "",
            cut_price: "",
            button_text: "",
        },
        dialog: {
            title: "",
            possitive_btn: "",
            negative_btn: "",
        },
        active: false,
    }
}

export { offerForm }

